import axiosInstance from "./axiosInstance";

export const getProducts = async (filters = {}, { signal } = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.query) {
      params.append("q", filters.query);
    }
    if (filters.categoryId) {
      params.append("categoryId", filters.categoryId);
    }
    if (filters.page) {
      params.append("page", filters.page);
    }
    if (filters.limit) {
      params.append("limit", filters.limit);
    }
    if (filters.discounted) {
      params.append("discounted", filters.discounted);
    }

    const queryString = params.toString();
    const url = queryString ? `/products?${queryString}` : "/products";

    const response = await axiosInstance.get(url, { signal });
    return response.data;
  } catch (error) {
    if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
      throw error;
    }
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getProductById = async (id) => {
  try {
    const response = await axiosInstance.get(`/products/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

export const getRelatedProducts = async (product) => {
  try {
    const response = await axiosInstance.get(
      `/products?categoryId=${product.categoryId}&limit=8`
    );
    const products = response.data.items || response.data || [];
    return products.filter((p) => p._id !== product._id);
  } catch (error) {
    console.error('Error fetching related products:', error);
    return [];
  }
};
